import React from "react";
import styles from "./Messagingemail.module.css";
import Inbox from "./Inbox";
import SendItems from "./Senditems";
import { CustomTab } from "../../../components";
import { useSelector } from "react-redux";
import { TokenService } from "../../../services/Api";

const MessagingEmail = () => {
  // const [searchQuery, setSearchQuery] = useState("");
  const { translations } = useSelector((state) => state.language);
  const user = TokenService.getUser();
  const roleId = Number(user?.role?.id);
  // Students (4) and Parents (6) cannot send messages, so hide Sent Items
  const isParentOrStudent = roleId === 4 || roleId === 6;

  const tabs = [
    {
      label: translations.labels.inbox,
      content: <Inbox />,
    },
    ...(!isParentOrStudent
      ? [
          {
            label: translations.labels.sentItems,
            content: <SendItems />,
          },
        ]
      : []),
  ];

  return (
    <div className={styles.messagingEmailContainer}>
      {/* <div className={styles.searchSection}>
        <CustomTextInput
          name="search"
          value={searchQuery}
          onChange={handleSearchChange}
          placeholder="Search here..."
          icon={<i className="fas fa-search"></i>}
          iconPosition="left"
          className={styles.searchInput}
        />
      </div> */}

      <div className={styles.tabSection}>
        <CustomTab tabs={tabs} defaultActiveTab={0} />
      </div>
    </div>
  );
};

export default MessagingEmail;
